import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';

import { SectionBase } from './SectionBase';

export const SectionNumber = ({
  title,
  subTitle,
  helpText,
  error,
  questionId,
  value,
  onChange,
  guidanceText,
}) => {
  const [reload, setReload] = React.useState(false);

  const handleChange = useCallback(
    event => {
      onChange(questionId, event.target.value);
    },
    [questionId, onChange],
  );

  useEffect(() => {
    if (value === undefined) {
      setReload(true);
      setTimeout(() => {
        setReload(false);
      }, 0);
    }
  }, [value]);

  return (
    <SectionBase
      {...{ title, subTitle, helpText, error, guidanceText, questionId }}
    >
      {!reload && <NumberField {...{ value }} onChange={handleChange} />}
    </SectionBase>
  );
};

const NumberField = styled(TextField).attrs({
  fullWidth: true,
  type: 'number',
  min: 0,
  step: '.01',
})`
  margin-top: 20px !important;
  background-color: #ffffff !important;
`;
